<template>
  <VaSidebar v-model="writableVisible" :width="sidebarWidth" :color="color" minimized-width="0">
    <VaAccordion v-model="value" multiple>
      <VaCollapse v-for="route in NavigationRoutes.routes" :key="route.name">
        <template #header>
          <VaSidebarItem
            :to="{ name: route.href }"
            :active="isActiveRoute(route.href ?? '')"
            :active-color="activeColor"
            :text-color="textColor(route.href ?? '')"
            :aria-label="`Visit ${route.name.toLowerCase()} page`"
            role="button"
            hover-opacity="0.10"
          >
            <VaSidebarItemContent class="py-3 pl-4 pr-2">
              <VaIcon :name="route.icon" size="20px" />
              <VaSidebarItemTitle class="flex items-center justify-between font-semibold leading-5">
                {{ route.name }} <VaIcon v-if="route.childrenRoutes" :name="'va-arrow-down'" />
              </VaSidebarItemTitle>
            </VaSidebarItemContent>
          </VaSidebarItem>
        </template>

        <template v-if="route.childrenRoutes" #body>
          <VaSidebarItem
            v-for="(childRoute, i) in route.childrenRoutes"
            :key="`childrenRoute_${i}`"
            :to="{ name: childRoute.href }"
            :active="isActiveRoute(childRoute.href)"
            :active-color="activeColor"
            :text-color="textColor(childRoute.href ?? '')"
            role="button"
            hover-opacity="0.10"
          >
            <VaSidebarItemContent class="py-3 pl-11 pr-2">
              <VaIcon :name="childRoute.icon" size="20px" />
              <VaSidebarItemTitle class="font-semibold leading-5">{{ childRoute.name }}</VaSidebarItemTitle>
            </VaSidebarItemContent>
          </VaSidebarItem>
        </template>
      </VaCollapse>
    </VaAccordion>

    <VaSpacer />

    <VaDivider />

    <VaSidebarItem :to="{ name: 'planos' }" role="button" hover-opacity="0.10" hover-color="secondary">
      <VaSidebarItemContent>
        <VaIcon name="mso-diamond_shine" size="20px" color="info" />
        <VaSidebarItemTitle class="font-semibold text-info">Atualizar Plano</VaSidebarItemTitle>
        <VaBadge text="novo" color="info" />
      </VaSidebarItemContent>
    </VaSidebarItem>

    <VaSidebarItem disabled hover-opacity="0.10">
      <VaSidebarItemContent class="py-3 pl-4 pr-2">
        <VaIcon name="mso-live_help" size="20px" />
        <VaSidebarItemTitle class="font-semibold">FAQ</VaSidebarItemTitle>
      </VaSidebarItemContent>
    </VaSidebarItem>

    <VaSidebarItem
      href="https://wa.me/5541988514680?text=Olá! Preciso de ajuda e suporte com o painel empresas Rolê de Boa."
      target="_blank"
      hover-opacity="0.10"
      hover-color="secondary"
    >
      <VaSidebarItemContent class="py-3 pl-4 pr-2">
        <VaIcon name="mso-support" size="20px" />
        <VaSidebarItemTitle class="font-semibold">Ajuda e Suporte</VaSidebarItemTitle>
        <VaIcon name="mso-open_in_new" color="secondary" />
      </VaSidebarItemContent>
    </VaSidebarItem>

    <VaSidebarItem hover-opacity="0.25" hover-color="danger" @click="logout">
      <VaSidebarItemContent class="py-3 pl-4 pr-2">
        <VaIcon name="mso-logout" size="20px" />
        <VaSidebarItemTitle class="font-semibold">Sair</VaSidebarItemTitle>
      </VaSidebarItemContent>
    </VaSidebarItem>
  </VaSidebar>
</template>
<script lang="ts">
import { defineComponent, computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useColors } from 'vuestic-ui'
import { authServices } from '@/features/auth'
import NavigationRoutes from './navigationRoutes'

export default defineComponent({
  name: 'Sidebar',
  props: {
    visible: { type: Boolean, default: true },
    mobile: { type: Boolean, default: false },
  },
  emits: ['update:visible'],

  setup: (props, { emit }) => {
    const value = ref([])
    const { getColor, colorToRgba } = useColors()
    const route = useRoute()

    const writableVisible = computed({
      get: () => props.visible,
      set: (v: boolean) => emit('update:visible', v),
    })
    const sidebarWidth = computed(() => (props.mobile ? '100vw' : '280px'))
    const color = computed(() => getColor('background-secondary'))
    const activeColor = computed(() => colorToRgba(getColor('focus'), 0.1))

    const isActiveRoute = (navRoute: string) => route.path.slice(1).split('/').slice(-1)[0] === navRoute
    const iconColor = (navRoute: string) => (isActiveRoute(navRoute) ? 'primary' : 'secondary')
    const textColor = (navRoute: string) => (isActiveRoute(navRoute) ? 'primary' : 'textPrimary')

    const { push } = useRouter()

    async function logout() {
      const { ok } = await authServices.signOut()
      ok && push({ name: 'login' })
    }

    return {
      writableVisible,
      sidebarWidth,
      color,
      activeColor,
      NavigationRoutes,
      value,
      isActiveRoute,
      iconColor,
      textColor,
      logout,
    }
  },
})
</script>
